import React from "react";

import { observer } from "mobx-react-lite";

import { NodeErrorCallout } from "src/nodeEditor/NodeErrorCallout";
import { TestRunErrorSelector } from "src/nodeEditor/TestRunErrorSelector";
import { SchemaHistoricalErrorCallout } from "src/schema/SchemaErrorCallout/SchemaHistoricalErrorCallout";
import { useNodeRunState } from "src/store/runState/RunState";
import { useGraphStore } from "src/store/StoreProvider";
import { getFormattedErrorDisplayMessages } from "src/utils/connectErrors";
import { errorMessage } from "src/utils/stringUtils";

export const SchemaErrorCallout: React.FC<{
  workspaceUrl: string;
}> = observer(({ workspaceUrl }) => {
  const {
    inputNode,
    outputNode,
    selectedNode,
    displayedErroredRow,
    setDisplayedErroredRow,
    resultsOutdated,
  } = useGraphStore();

  const inputNodeRunState = useNodeRunState(inputNode?.id ?? "");
  const outputNodeRunState = useNodeRunState(outputNode?.id ?? "");
  const selectedNodeRunState = useNodeRunState(selectedNode?.id ?? "");
  if (
    inputNode &&
    outputNode &&
    (inputNodeRunState?.type === "historical-error" ||
      outputNodeRunState?.type === "historical-error")
  ) {
    const failingInput = (() => {
      if (inputNodeRunState?.type === "historical-error") {
        return inputNodeRunState.error.data;
      } else if (outputNodeRunState?.type === "historical-error") {
        return outputNodeRunState?.error.data;
      }
    })();
    return <SchemaHistoricalErrorCallout failingInput={failingInput} />;
  } else if (
    selectedNode &&
    selectedNodeRunState?.type === "test-run" &&
    (selectedNode === inputNode || selectedNode === outputNode)
  ) {
    return (
      <TestRunErrorSelector
        displayedFailure={displayedErroredRow}
        resultsOutdated={resultsOutdated}
        selectedNodeId={selectedNode?.id}
        setDisplayedFailure={setDisplayedErroredRow}
        testResult={selectedNodeRunState.testResult}
        workspaceUrl={workspaceUrl}
      />
    );
  } else if (
    selectedNode &&
    selectedNodeRunState?.type === "job-run" &&
    displayedErroredRow &&
    (selectedNode === inputNode || selectedNode === outputNode)
  ) {
    const errorSections = getFormattedErrorDisplayMessages(
      errorMessage(displayedErroredRow.msg),
    );
    return (
      <div className="mx-5 mt-4 mb-4">
        <NodeErrorCallout
          errorSections={errorSections}
          failingInput={displayedErroredRow.data}
        />
      </div>
    );
  }
  return <></>;
});
